import AnalyticDefinition from "state/analytics/AnalyticDefinition";
import { deleteDefinition } from "state/grid/util";
import {
  DELETE_DEFINITION,
  RECEIVE_ANALYTIC_VALUES,
  RECEIVE_ANALYTICS_DATA,
  REQUEST_ANALYTIC_VALUES,
  REQUEST_ANALYTICS_DATA,
  SET_DEFINITION,
  SET_DEFINITIONS,
  RECEIVE_ANALYTICS_SBS_DATA,
  REQUEST_ANALYTICS_SBS_DATA,
  REQUEST_ANALYTICS_RATIO_DATA,
  RECEIVE_ANALYTICS_RATIO_DATA,
} from "./actions";
import SelectionState from "state/selections/SelectionState";
import { SummaryType } from "@ls/grouping-service";
import { COMMIT_SELECTIONS } from "state/selections/actions";
import { produce } from "immer";

const defaultState = {
  definitions: {
    [SelectionState.UNCOMMITTED]: [AnalyticDefinition.getDefault()],
    [SelectionState.COMMITTED]: [],
  },
  fetchingAnalyticsValues: false,
  analyticsValues: [],
  fetchingAnalyticsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  analyticsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingAnalyticsRatioData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  analyticsRatioData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
  fetchingAnalyticsSbsData: {
    [SummaryType.ABSOLUTE]: false,
    [SummaryType.RELATIVE]: false,
  },
  analyticsSbsData: {
    [SummaryType.ABSOLUTE]: null,
    [SummaryType.RELATIVE]: null,
  },
};

export default produce((state = defaultState, action) => {
  switch (action.type) {
    case SET_DEFINITION: {
      const { definition, idx } = action;
      const selectedDefinitions = state.definitions[SelectionState.UNCOMMITTED];
      if (definition === null) {
        selectedDefinitions.splice(idx, 1);
      } else {
        selectedDefinitions[idx] = definition;
      }
      break;
    }

    case DELETE_DEFINITION:
      state.definitions = deleteDefinition(state.definitions, action.payload);
      break;
    case SET_DEFINITIONS: {
      state.definitions[SelectionState.UNCOMMITTED] = action.definitions;
      break;
    }
    case COMMIT_SELECTIONS: {
      state.analyticsData = defaultState.analyticsData;
      state.definitions[SelectionState.COMMITTED] =
        state.definitions[SelectionState.UNCOMMITTED];
      break;
    }
    case REQUEST_ANALYTIC_VALUES: {
      state.fetchingAnalyticValues = true;
      state.analyticValues = defaultState.analyticValues;
      break;
    }
    case RECEIVE_ANALYTIC_VALUES: {
      state.fetchingAnalyticValues = false;
      state.analyticValues = action.data;
      break;
    }
    case REQUEST_ANALYTICS_DATA: {
      state.fetchingAnalyticsData[action.summary] = true;
      state.analyticsData[action.summary] =
        defaultState.analyticsData[action.summary];
      break;
    }
    case RECEIVE_ANALYTICS_DATA: {
      state.fetchingAnalyticsData[action.summary] = false;
      state.analyticsData[action.summary] = action.data;
      break;
    }
    case REQUEST_ANALYTICS_SBS_DATA: {
      state.fetchingAnalyticsSbsData[action.summary] = true;
      state.analyticsSbsData[action.summary] =
        defaultState.analyticsSbsData[action.summary];
      break;
    }
    case RECEIVE_ANALYTICS_SBS_DATA: {
      state.fetchingAnalyticsSbsData[action.summary] = false;
      state.analyticsSbsData[action.summary] = action.data;
      break;
    }
    case REQUEST_ANALYTICS_RATIO_DATA: {
      state.fetchingAnalyticsRatioData[action.summary] = true;
      state.analyticsRatioData[action.summary] =
        defaultState.analyticsRatioData[action.summary];
      break;
    }
    case RECEIVE_ANALYTICS_RATIO_DATA: {
      state.fetchingAnalyticsRatioData[action.summary] = false;
      state.analyticsRatioData[action.summary] = action.data;
      break;
    }
    default:
      return state;
  }
});
